import { Image, Page, StyleSheet, View } from '@react-pdf/renderer';
import { ReactNode } from 'react';
import backgroundImage from 'src/shared/assets/img/certificate_bg_0.png';
import { FooterPDF } from './FooterPDF';
import { HeaderPDF } from './HeaderPDF';

const styles = StyleSheet.create({
	page: {
		fontSize: 10,
		fontFamily: 'Poppins, sans-serif',
	},

	background: {
		position: 'absolute',
		left: 0,
		top: 0,
		zIndex: '-1',
		width: '100%',
		height: '100%',
	},

	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		fontSize: 12,
	},
	content: {
		flexDirection: 'column',
		padding: '50',
		color: '#fff',
	},
});

interface Props {
	dateOfIssue: string;
	expirationDate: string;
	children: ReactNode;
}

export const PageDecoratorPDF: React.FC<Props> = (props) => {
	const {
		dateOfIssue, //
		expirationDate,
		children,
	} = props;

	return (
		<Page
			size="A4"
			style={styles.page}
		>
			<View style={styles.container}>
				<HeaderPDF
					dateOfIssue={dateOfIssue}
					expirationDate={expirationDate}
				/>

				<View style={styles.content}>{children}</View>

				<FooterPDF />
			</View>

			<Image
				src={backgroundImage}
				style={styles.background}
			/>
		</Page>
	);
};
